import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthResponsable } from '../common/AuthResponsable'

import { AuthCompromis, AuthCompromisMenors16 } from './AuthCompromis'
import { AuthPortatils } from './AuthPortatils'
import { AuthRecursosDigitals } from './AuthRecursosDigitals'
import { AuthDretsImatge } from './AuthDretsImatge'
import { AuthGDPR } from '../common/AuthGDPR'
import { AuthSortides, AuthSortidesMenors } from './AuthSortides'
import { AuthMedica, AuthMedicaMenors } from './AuthMedica'
import { AuthAMPA } from './AuthAMPA'
import { AuthDocumentacioExtra } from './AuthDocumentacioExtra'
import { AuthAlumnatEstranger } from './AuthAlumnatEstranger'
import { AuthErasmus } from './AuthErasmus'
import { AuthPractiquesEmpresa } from './AuthPractiquesEmpresa'
import { AuthEdat17 } from '../common/AuthEdat17'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }


  const [authDretsImatge, setAuthDretsImatge] = useState("0");

  const [authCompromis, setAuthCompromis] = useState("0");
  const [authGDPR, setAuthGDPR] = useState("0");
  const [authSortides, setAuthSortides] = useState("0");
  const [authAMPA, setAuthAMPA] = useState("0");
  const [authMedica, setAuthMedica] = useState("0");
  const [authResponsable, setAuthResponsable] = useState("0");
  const [authPortatils, setAuthPortatils] = useState("");
  const [authRecursosDigitals, setAuthRecursosDigitals] = useState("0");
  const [authDocumentacioExtra, setAuthDocumentacioExtra] = useState("0");
  const [authAlumnatEstranger, setAuthAlumnatEstranger] = useState("");
  //const [erasmusConcedit, setErasmusConcedit] = useState("0");
  const [authErasmus, setAuthErasmus] = useState("");
  const [authPractiquesEmpresa, setAuthPractiquesEmpresa] = useState("0");

  //const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
      "validat": noError,

      /* DADES AUTORITZACIONS */
      "authCompromis": authCompromis,
      "authGDPR": authGDPR,
      "authDretsImatge": authDretsImatge,
      "authSortides": authSortides,
      "authMedica": authMedica,
      "authResponsable": authResponsable
    }

    if (authAMPACriteri) d.authAMPA = authAMPA
    if (authDocumentacioExtraCriteri) d.authDocumentacioExtra = authDocumentacioExtra
    if (authErasmusCriteri) d.authErasmus = authErasmus
    if (authPractiquesEmpresa) d.authPractiquesEmpresa = authPractiquesEmpresa
    if (authAlumnatEstrangerCriteri) d.authAlumnatEstranger = authAlumnatEstranger
    if (authPortatils) d.authPortatils = authPortatils
    if (authRecursosDigitals) d.authRecursosDigitals = authRecursosDigitals

    //console.log("DADES_AUTORITZACIONS",d)
    //setDadesAutoritzacions(d)
    props.handleDadesAutoritzacions(d)
  }



  /* CRITERIS */

  const major18 = props.dadesPersonals.edat >= 18 || false
  const major16 = props.dadesPersonals.edat >= 16 || false

  const authAMPACriteri = props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS"
  const authDocumentacioExtraCriteri = props.dadesEstudis.nouAlumne && (props.dadesEstudis.curs.id.startsWith("BATXLOE") || props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS")
  const authErasmusCriteri = props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS"
  const authPractiquesEmpresaCriteri = props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS"
  const authAlumnatEstrangerCriteri = props.dadesEstudis.cicle === "CFGM" || props.dadesEstudis.cicle === "CFGS" || props.dadesEstudis.cicle === "BATX"
  const authPortatilsCriteri = props.dadesEstudis.curs.id.startsWith("ESOLOE")
  const authSortidesCriteri = major18 // obligatori als majors de 18 pero es mostra en tots els casos


  /* VALIDACIONS */

  const validaAuthDretsImatge = () => {
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }


  const validaAuthSortides = () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPortatils = () => {
    return authPortatils !== "" ? null : "Aquest camp és obligatori"
  }

  const validaAuthDocumentacioExtra = () => {
    return authDocumentacioExtra === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthAlumnatEstranger = () => {
    return authAlumnatEstranger !== "" ? null : "Heu de triar una de les opcions"
  }

  const validaAuthErasmus = () => {
    return authErasmus !== "" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPractiquesEmpresa = () => {
    return authPractiquesEmpresa === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR = () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable = () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const handleAuthDretsImatge = (t) => {

    setAuthDretsImatge(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }


  const handleChangeCompromis = (t) => {

    setAuthCompromis(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangeGDPR = (t) => {

    setAuthGDPR(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangeResponsable = (t) => {

    setAuthResponsable(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangePortatils = (t) => {

    setAuthPortatils(t)

    handleDadesAutoritzacions(false)
  }

  const handleChangeSortides = (t) => {

    setAuthSortides(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangeAMPA = (t) => {

    setAuthAMPA(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangeMedica = (t) => {

    setAuthMedica(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangeRecursosDigitals = (t) => {

    setAuthRecursosDigitals(t === "0" ? "1" : "0")

    if (t === "1") handleDadesAutoritzacions(false)
  }

  const handleChangeAlumnatEstranger = (t) => {

    setAuthAlumnatEstranger(t)

    handleDadesAutoritzacions(false)
  }


  const handleChangeDocumentacioExtra = (t) => {

    setAuthDocumentacioExtra(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }


  /*
  const handleChangeErasmusConcedit= (t) => {

       setErasmusConcedit(t === "0" ? "1" : "0")

       handleDadesAutoritzacions(false)
  }
   */

  const handleChangeErasmus = (t) => {

    setAuthErasmus(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }

  const handleChangePractiquesEmpresa = (t) => {

    setAuthPractiquesEmpresa(t === "0" ? "1" : "0")

    handleDadesAutoritzacions(false)
  }



  /* VALIDA AUTORITZACIONS */
  const validaAutoritzacions = (e) => {
    if (e) e.preventDefault();

    let error = {}

    error.authCompromis = validaAuthCompromis();
    handleErrors('authCompromis', error)

    if (authPortatilsCriteri) {
      error.authPortatils = validaAuthPortatils();
      handleErrors('authPortatils', error)
    }

    if (authDocumentacioExtraCriteri) {
      error.authDocumentacioExtra = validaAuthDocumentacioExtra();
      handleErrors('authDocumentacioExtra', error)
    }

    if (authAlumnatEstrangerCriteri) {
      error.authAlumnatEstranger = validaAuthAlumnatEstranger();
      handleErrors('authAlumnatEstranger', error)
    }

    if (authErasmusCriteri) {

      //if (erasmusConcedit === "1") {
      error.authErasmus = validaAuthErasmus()
      handleErrors('authErasmus', error)
      //}
    }

    if (authPractiquesEmpresaCriteri) {
      error.authPractiquesEmpresa = validaAuthPractiquesEmpresa();
      handleErrors('authPractiquesEmpresa', error)
    }

    error.authGDPR = validaAuthGDPR();
    handleErrors('authGDPR', error)

    error.authResponsable = validaAuthResponsable();
    handleErrors('authResponsable', error)

    error.authDretsImatge = validaAuthDretsImatge();
    handleErrors('authDretsImatge', error)

    if (authSortidesCriteri) {

      error.authSortides = validaAuthSortides();
      handleErrors('authSortides', error)
    }


    setErrors(error)

    let noError = true;
    //DEVELOP
    if (!config.develop) // bypass errors if develop == true
    {
      Object.keys(error).forEach((k) => { if (error[k] !== null) noError = false })
      console.log('ERROR', error);
    }

    handleDadesAutoritzacions(noError)

    if (noError) {
      setAuthorizationsOpen(false);
    }

    return noError;
  }

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                {major16 ? (
                                  <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                ) : (
                                  <AuthCompromisMenors16 auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />
                                )}

                                {authPortatilsCriteri && (
                                  <AuthPortatils auth={authPortatils} handleChange={handleChangePortatils} error={errors.authPortatils} />
                                )}

                                <AuthDretsImatge auth={authDretsImatge} handleChange={handleAuthDretsImatge} error={errors.authDretsImatge} major18={major18} />

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                {!major18 ? (
                                  <AuthSortidesMenors auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} curs={props.dadesEstudis.curs} cicle={props.dadesEstudis.cicle} />
                                ) : (
                                  <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                )}

                                {!major18 ? (
                                  <AuthMedicaMenors auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} />
                                ) : (
                                  <AuthMedica auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} />
                                )}

                                {authAMPACriteri && (
                                  <AuthAMPA auth={authAMPA} handleChange={handleChangeAMPA} error={errors.authAMPA} />
                                )}

                                {authDocumentacioExtraCriteri && (
                                  <AuthDocumentacioExtra auth={authDocumentacioExtra} handleChange={handleChangeDocumentacioExtra} error={errors.authDocumentacioExtra} />
                                )}

                                {authAlumnatEstrangerCriteri && (
                                  <AuthAlumnatEstranger auth={authAlumnatEstranger} handleChange={handleChangeAlumnatEstranger} error={errors.authAlumnatEstranger} />
                                )}

                                {authErasmusCriteri && (
                                  <AuthErasmus auth={authErasmus} handleChange={handleChangeErasmus} error={errors.authErasmus} enguany={props.enguany} />
                                )}

                                {authPractiquesEmpresaCriteri && (
                                  <AuthPractiquesEmpresa auth={authPractiquesEmpresa} handleChange={handleChangePractiquesEmpresa} error={errors.authPractiquesEmpresa} />
                                )}

                                <AuthRecursosDigitals auth={authRecursosDigitals} handleChange={handleChangeRecursosDigitals} error={errors.authRecursosDigitals} edat={props.dadesPersonals.edat} />

                                <br />

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable} />

                                <AuthEdat17 edat={props.dadesPersonals.edat} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                      </div>
                    </div>
                  </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
